import { headers } from 'api';
import { WhiteButton, BlueButton } from 'components/atoms';
import { Modal } from 'components/molecules';
import { toast } from 'react-toastify';

import * as S from './styles';

export const ModalReClassificar = ({ id, isOpen, onClose }) => {
  const handleSubmit = () => {
    fetch(`${process.env.REACT_APP_API_URL}/processo-aluno/${id}/reclassificar/`, {
      method: 'POST',
      headers: {
        ...headers,
        authorization: sessionStorage.getItem('@senac:token'),
      },
    })
      .then((response) => {
        if (response.ok) {
          toast.success('Aluno classificado com sucesso.');
          onClose();
        } else {
          toast.error('Erro ao reclassificar o aluno.');
        }
      })
      .catch(() => {
        toast.error('Erro ao reclassificar o aluno.');
      });
  };

  return (
    <Modal title="Reclassificar" isOpen={isOpen} onClose={onClose}>
      <S.ModalContent>
        <p>Deseja reclassificar o aluno?</p>
        <div className="buttons">
          <WhiteButton onClick={onClose}>Não</WhiteButton>
          <BlueButton onClick={handleSubmit}>Sim</BlueButton>
        </div>
      </S.ModalContent>
    </Modal>
  );
};
